/**
 * App version for display (footer, profile, settings)
 * Set VITE_APP_VERSION in .env or build (e.g. VITE_APP_VERSION=1.2.0)
 */
export const APP_VERSION =
  import.meta.env.VITE_APP_VERSION ?? 'dev';
